const checkAccess = (menu, val) => {
  const item = doesPathExist(menu, val);
  const access = {
    // create: true,
    // read: true,
    // update: true,
    // delete: true,
    // view: false,
    others: [],
    create: false,
    read: false,
    update: false,
    delete: false,
    view: false,
  };

  item.forEach((data) => {
    switch (data.label) {
      case "Create":
        access.create = true;
        break;
      case "Read":
        access.read = true;
        break;
      case "Update":
        access.update = true;
        break;
      case "Delete":
        access.delete = true;
        break;
      case "View":
        access.view = true;
        break;
      default:
        access.others = [...access.others, data.accessControlId];
    }
  });
  return access;
};

const doesPathExist = (menu, val) => {
  if (menu?.length)
    for (const item of menu) {
      if (
        val.toLowerCase() === "amenityDashboard".toLowerCase() ||
        val.toLowerCase() === "amenityDetails".toLowerCase() ||
        val.toLowerCase() === "amenityBooking".toLowerCase() ||
        val.toLowerCase() === "AmenityBookingDetails".toLowerCase() ||
        val.toLowerCase() === "notifications".toLowerCase()
      ) {
        return true;
      } else if (item.router.toLowerCase() === val.toLowerCase()) {
        return item.selectedApplicationAccessControlList;
      } else if (
        item.router.toLowerCase() === "" &&
        val.toLowerCase() === "topuser"
      ) {
        return true;
      } else if (item.subModules?.length > 0 && Array.isArray(item.subModules)) {
        const accessControlList = doesPathExist(item.subModules, val);


        if (accessControlList) {
          return accessControlList;
        }
      }
    }
  // 🔑 Special case: if "wallet" exists in menu, allow its child routes
  if (menu?.some(item => item.router.toLowerCase() === "wallet")) {
    const walletChildren = ["transaction-history", "beneficiaries", "withdraw","schedule-of-charges"];
    if (walletChildren.includes(val.toLowerCase())) {
      return true;
    }
  }
  return null;
};



export { checkAccess, doesPathExist };
